export default __webpack_public_path__ + "static/media/post_office_reactJS.60e5c992.PNG";